module.exports = __webpack_public_path__ + "static/media/noartwork.694a1abb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noartwork.jpg
// module id = 235
// module chunks = 0